var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.deviceType != 'mobile')?_c('std-fixed'):_vm._e(),_vm._v(" "),_c('indexContext')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }